import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Timestamp: any;
  DateTime: any;
};



export type Query = {
  __typename?: 'Query';
  kpiCompanyGet?: Maybe<KpiCompany>;
  kpiCompanyGetByExtId?: Maybe<KpiCompany>;
  kpiCompanyList?: Maybe<Array<Maybe<KpiCompany>>>;
  kpiCompanyListAssigned?: Maybe<Array<Maybe<KpiCompany>>>;
  kpiCompaniesPing?: Maybe<Scalars['String']>;
  kpiIndicatorGet?: Maybe<KpiIndicator>;
  kpiIndicatorGetGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  kpiIndicatorList?: Maybe<Array<Maybe<KpiIndicator>>>;
  kpiIndicatorsPing?: Maybe<Scalars['String']>;
  kpiTemplateGet?: Maybe<KpiTemplate>;
  kpiTemplateList?: Maybe<Array<Maybe<KpiTemplate>>>;
  kpiTemplatesPing?: Maybe<Scalars['String']>;
  kpiDataVersionGetCurrent?: Maybe<KpiDataVersion>;
  kpiDataVersionGetPublished?: Maybe<KpiDataVersion>;
  kpiDataVersionListPublished?: Maybe<Array<Maybe<KpiDataVersion>>>;
  kpiDataVersionListAudits?: Maybe<Array<Maybe<KpiDataVersionChangeAudit>>>;
  kpiDataVersionPing?: Maybe<Scalars['String']>;
};


export type QueryKpiCompanyGetArgs = {
  id: Scalars['String'];
};


export type QueryKpiCompanyGetByExtIdArgs = {
  extId: Scalars['String'];
};


export type QueryKpiIndicatorGetArgs = {
  id: Scalars['String'];
};


export type QueryKpiTemplateGetArgs = {
  id: Scalars['String'];
};


export type QueryKpiDataVersionGetCurrentArgs = {
  companyId: Scalars['String'];
};


export type QueryKpiDataVersionGetPublishedArgs = {
  companyId: Scalars['String'];
};


export type QueryKpiDataVersionListAuditsArgs = {
  companyId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  kpiCompanySetDataCollectionFrequency?: Maybe<KpiCompany>;
  kpiCompanySetDataCollectionStartDate?: Maybe<KpiCompany>;
  kpiCompanyUpdateTemplate?: Maybe<KpiCompany>;
  kpiIndicatorAdd?: Maybe<KpiIndicator>;
  kpiIndicatorDelete?: Maybe<KpiIndicator>;
  kpiIndicatorUpdate?: Maybe<KpiIndicator>;
  kpiIndicatorUpsert?: Maybe<KpiIndicator>;
  kpiIndicatorUpsertBulk?: Maybe<Array<Maybe<KpiIndicator>>>;
  kpiTemplateAdd?: Maybe<KpiTemplate>;
  kpiTemplateDelete?: Maybe<KpiTemplate>;
  kpiTemplateUpdate?: Maybe<KpiTemplate>;
  kpiTemplateUpsert?: Maybe<KpiTemplate>;
  kpiTemplateUpsertBulk?: Maybe<Array<Maybe<KpiTemplate>>>;
  kpiTemplateIndicatorAdd?: Maybe<KpiTemplate>;
  kpiTemplateIndicatorDelete?: Maybe<KpiTemplate>;
  kpiDataVersionLock?: Maybe<KpiDataVersion>;
  kpiDataVersionPublish?: Maybe<KpiDataVersion>;
  kpiDataVersionUpdateData?: Maybe<Array<Maybe<KpiDataVersionData>>>;
  kpiDataVersionUnlock?: Maybe<KpiDataVersion>;
};


export type MutationKpiCompanySetDataCollectionFrequencyArgs = {
  id: Scalars['String'];
  period: Scalars['String'];
};


export type MutationKpiCompanySetDataCollectionStartDateArgs = {
  id: Scalars['String'];
  date: Scalars['String'];
};


export type MutationKpiCompanyUpdateTemplateArgs = {
  id: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
};


export type MutationKpiIndicatorAddArgs = {
  input?: Maybe<KpiIndicatorAddInput>;
};


export type MutationKpiIndicatorDeleteArgs = {
  id: Scalars['String'];
};


export type MutationKpiIndicatorUpdateArgs = {
  input?: Maybe<KpiIndicatorUpdateInput>;
};


export type MutationKpiIndicatorUpsertArgs = {
  input?: Maybe<KpiIndicatorUpsertInput>;
};


export type MutationKpiIndicatorUpsertBulkArgs = {
  input?: Maybe<Array<Maybe<KpiIndicatorUpsertInput>>>;
};


export type MutationKpiTemplateAddArgs = {
  input?: Maybe<KpiTemplateAddInput>;
};


export type MutationKpiTemplateDeleteArgs = {
  id: Scalars['String'];
};


export type MutationKpiTemplateUpdateArgs = {
  input?: Maybe<KpiTemplateUpdateInput>;
};


export type MutationKpiTemplateUpsertArgs = {
  input?: Maybe<KpiTemplateUpsertInput>;
};


export type MutationKpiTemplateUpsertBulkArgs = {
  input?: Maybe<Array<Maybe<KpiTemplateUpsertInput>>>;
};


export type MutationKpiTemplateIndicatorAddArgs = {
  id: Scalars['String'];
  indicatorId: Scalars['String'];
};


export type MutationKpiTemplateIndicatorDeleteArgs = {
  id: Scalars['String'];
  indicatorId: Scalars['String'];
};


export type MutationKpiDataVersionLockArgs = {
  companyId: Scalars['String'];
};


export type MutationKpiDataVersionPublishArgs = {
  companyId: Scalars['String'];
};


export type MutationKpiDataVersionUpdateDataArgs = {
  companyId: Scalars['String'];
  data?: Maybe<Array<Maybe<KpiDataVersionDataInput>>>;
};


export type MutationKpiDataVersionUnlockArgs = {
  companyId: Scalars['String'];
};

export type KpiGlobalUser = {
  __typename?: 'KpiGlobalUser';
  id?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type KpiCompanyInvestment = {
  __typename?: 'KpiCompanyInvestment';
  extId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  currencySign?: Maybe<Scalars['String']>;
  fundId?: Maybe<Scalars['String']>;
  fundName?: Maybe<Scalars['String']>;
  investmentAmount?: Maybe<Scalars['Float']>;
  investmentDate?: Maybe<Scalars['Date']>;
};

export type KpiCompanyDataCollectionFrequency = {
  __typename?: 'KpiCompanyDataCollectionFrequency';
  period?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<KpiGlobalUser>;
};

export type KpiCompanyDataCollectionStartDate = {
  __typename?: 'KpiCompanyDataCollectionStartDate';
  date?: Maybe<Scalars['Date']>;
  updated?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<KpiGlobalUser>;
};

export type KpiCompanyStatus = {
  __typename?: 'KpiCompanyStatus';
  status?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  user?: Maybe<KpiGlobalUser>;
};

export type KpiCompany = {
  __typename?: 'KpiCompany';
  id?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  extId?: Maybe<Scalars['String']>;
  extStatus?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  investments?: Maybe<Array<Maybe<KpiCompanyInvestment>>>;
  sectors?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastStatus?: Maybe<KpiCompanyStatus>;
  dataCollectionFrequency?: Maybe<Array<Maybe<KpiCompanyDataCollectionFrequency>>>;
  dataCollectionStartDate?: Maybe<Array<Maybe<KpiCompanyDataCollectionStartDate>>>;
  lastPublished?: Maybe<Scalars['DateTime']>;
  lastPublishedBy?: Maybe<KpiGlobalUser>;
  created?: Maybe<Scalars['DateTime']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export enum KpiIndicatorStatus {
  Active = 'active',
  Deleted = 'deleted'
}

export type KpiIndicator = {
  __typename?: 'KpiIndicator';
  id?: Maybe<Scalars['ID']>;
  accountId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  status?: Maybe<KpiIndicatorStatus>;
  created?: Maybe<Scalars['DateTime']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type KpiIndicatorAddInput = {
  name: Scalars['String'];
  type: Scalars['String'];
  group: Scalars['String'];
  status: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};


export type KpiIndicatorUpsertInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  group: Scalars['String'];
  status: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export enum KpiTemplateStatus {
  Active = 'active',
  Inactive = 'inactive',
  Deleted = 'deleted'
}

export type KpiTemplateIndicator = {
  __typename?: 'KpiTemplateIndicator';
  id?: Maybe<Scalars['ID']>;
  order?: Maybe<Scalars['Int']>;
};

export type KpiTemplate = {
  __typename?: 'KpiTemplate';
  id?: Maybe<Scalars['ID']>;
  accountId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  indicators?: Maybe<Array<Maybe<KpiTemplateIndicator>>>;
  status?: Maybe<KpiTemplateStatus>;
  created?: Maybe<Scalars['DateTime']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type KpiTemplateIndicatorInput = {
  id: Scalars['String'];
  order: Scalars['Int'];
};

export type KpiTemplateAddInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  indicators: Array<Maybe<KpiTemplateIndicatorInput>>;
  status: Scalars['String'];
};

export type KpiTemplateUpdateInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  indicators?: Maybe<Array<Maybe<KpiTemplateIndicatorInput>>>;
  status?: Maybe<Scalars['String']>;
};

export type KpiTemplateUpsertInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  indicators?: Maybe<Array<Maybe<KpiTemplateIndicatorInput>>>;
  status: Scalars['String'];
};

export type KpiDataVersionChangeAudit = {
  __typename?: 'KpiDataVersionChangeAudit';
  changedBy?: Maybe<KpiGlobalUser>;
  changed?: Maybe<Scalars['DateTime']>;
  action?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type KpiDataVersionData = {
  __typename?: 'KpiDataVersionData';
  indicatorId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  period?: Maybe<Scalars['String']>;
};

export type KpiDataVersion = {
  __typename?: 'KpiDataVersion';
  id?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  editableByCurrentUser?: Maybe<Scalars['Boolean']>;
  templateId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  lockedBy?: Maybe<KpiGlobalUser>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  changeAudit?: Maybe<Array<Maybe<KpiDataVersionChangeAudit>>>;
  data?: Maybe<Array<Maybe<KpiDataVersionData>>>;
  created?: Maybe<Scalars['DateTime']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type KpiDataVersionDataInput = {
  indicatorId: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
  period: Scalars['String'];
};

export type KpiIndicatorUpdateInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type KpiCompanyUpdateTemplateMutationVariables = Exact<{
  id: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
}>;


export type KpiCompanyUpdateTemplateMutation = { __typename?: 'Mutation', kpiCompanyUpdateTemplate?: Maybe<{ __typename?: 'KpiCompany', id?: Maybe<string>, accountId?: Maybe<string>, extId?: Maybe<string>, extStatus?: Maybe<number>, name?: Maybe<string>, templateId?: Maybe<string>, sectors?: Maybe<Array<Maybe<string>>>, created?: Maybe<any>, updated?: Maybe<any> }> };

export type KpiCompanyListQueryVariables = Exact<{ [key: string]: never; }>;


export type KpiCompanyListQuery = { __typename?: 'Query', kpiCompanyList?: Maybe<Array<Maybe<{ __typename?: 'KpiCompany', id?: Maybe<string>, name?: Maybe<string>, templateId?: Maybe<string>, accountId?: Maybe<string>, extId?: Maybe<string>, extStatus?: Maybe<number>, sectors?: Maybe<Array<Maybe<string>>>, lastPublished?: Maybe<any>, created?: Maybe<any>, updated?: Maybe<any>, investments?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyInvestment', fundName?: Maybe<string>, investmentAmount?: Maybe<number>, investmentDate?: Maybe<any>, currency?: Maybe<string> }>>>, lastPublishedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }>, lastStatus?: Maybe<{ __typename?: 'KpiCompanyStatus', status?: Maybe<string>, date?: Maybe<any>, user?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>, dataCollectionStartDate?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyDataCollectionStartDate', date?: Maybe<any>, updated?: Maybe<any>, updatedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>>, dataCollectionFrequency?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyDataCollectionFrequency', period?: Maybe<string>, updated?: Maybe<any>, updatedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>> }>>> };

export type KpiCompanyGetQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type KpiCompanyGetQuery = { __typename?: 'Query', kpiCompanyGet?: Maybe<{ __typename?: 'KpiCompany', id?: Maybe<string>, name?: Maybe<string>, templateId?: Maybe<string>, accountId?: Maybe<string>, extId?: Maybe<string>, extStatus?: Maybe<number>, sectors?: Maybe<Array<Maybe<string>>>, lastPublished?: Maybe<any>, created?: Maybe<any>, updated?: Maybe<any>, investments?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyInvestment', fundName?: Maybe<string>, investmentAmount?: Maybe<number>, investmentDate?: Maybe<any>, currency?: Maybe<string> }>>>, lastPublishedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }>, dataCollectionStartDate?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyDataCollectionStartDate', date?: Maybe<any>, updated?: Maybe<any>, updatedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>>, dataCollectionFrequency?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyDataCollectionFrequency', period?: Maybe<string>, updated?: Maybe<any>, updatedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>> }> };

export type KpiDataVersionUpdateDataMutationVariables = Exact<{
  companyId: Scalars['String'];
  data?: Maybe<Array<Maybe<KpiDataVersionDataInput>>>;
}>;


export type KpiDataVersionUpdateDataMutation = { __typename?: 'Mutation', kpiDataVersionUpdateData?: Maybe<Array<Maybe<{ __typename?: 'KpiDataVersionData', name?: Maybe<string>, indicatorId?: Maybe<string>, type?: Maybe<string>, value?: Maybe<string>, period?: Maybe<string> }>>> };

export type KpiCompanySetDataCollectionFrequencyMutationVariables = Exact<{
  id: Scalars['String'];
  period: Scalars['String'];
}>;


export type KpiCompanySetDataCollectionFrequencyMutation = { __typename?: 'Mutation', kpiCompanySetDataCollectionFrequency?: Maybe<{ __typename?: 'KpiCompany', id?: Maybe<string>, created?: Maybe<any>, updated?: Maybe<any>, dataCollectionStartDate?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyDataCollectionStartDate', date?: Maybe<any>, updated?: Maybe<any>, updatedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>>, dataCollectionFrequency?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyDataCollectionFrequency', period?: Maybe<string>, updated?: Maybe<any>, updatedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>> }> };

export type KpiCompanySetDataCollectionStartDateMutationVariables = Exact<{
  id: Scalars['String'];
  date: Scalars['String'];
}>;


export type KpiCompanySetDataCollectionStartDateMutation = { __typename?: 'Mutation', kpiCompanySetDataCollectionStartDate?: Maybe<{ __typename?: 'KpiCompany', id?: Maybe<string>, created?: Maybe<any>, updated?: Maybe<any>, dataCollectionStartDate?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyDataCollectionStartDate', date?: Maybe<any>, updated?: Maybe<any>, updatedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>>, dataCollectionFrequency?: Maybe<Array<Maybe<{ __typename?: 'KpiCompanyDataCollectionFrequency', period?: Maybe<string>, updated?: Maybe<any>, updatedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>> }> };

export type KpiDataVersionPublishMutationVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type KpiDataVersionPublishMutation = { __typename?: 'Mutation', kpiDataVersionPublish?: Maybe<{ __typename?: 'KpiDataVersion', id?: Maybe<string>, accountId?: Maybe<string>, templateId?: Maybe<string>, created?: Maybe<any>, updated?: Maybe<any>, changeAudit?: Maybe<Array<Maybe<{ __typename?: 'KpiDataVersionChangeAudit', changed?: Maybe<any>, action?: Maybe<string>, changedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>>, lockedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }> };

export type KpiDataVersionLockMutationVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type KpiDataVersionLockMutation = { __typename?: 'Mutation', kpiDataVersionLock?: Maybe<{ __typename?: 'KpiDataVersion', id?: Maybe<string>, type?: Maybe<string>, editableByCurrentUser?: Maybe<boolean>, companyId?: Maybe<string>, lockedAt?: Maybe<any>, created?: Maybe<any>, updated?: Maybe<any>, data?: Maybe<Array<Maybe<{ __typename?: 'KpiDataVersionData', name?: Maybe<string>, indicatorId?: Maybe<string>, type?: Maybe<string>, value?: Maybe<string>, period?: Maybe<string> }>>>, lockedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }> };

export type KpiDataVersionUnlockMutationVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type KpiDataVersionUnlockMutation = { __typename?: 'Mutation', kpiDataVersionUnlock?: Maybe<{ __typename?: 'KpiDataVersion', id?: Maybe<string>, type?: Maybe<string>, editableByCurrentUser?: Maybe<boolean>, lockedAt?: Maybe<any>, created?: Maybe<any>, updated?: Maybe<any>, lockedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }>, data?: Maybe<Array<Maybe<{ __typename?: 'KpiDataVersionData', name?: Maybe<string>, indicatorId?: Maybe<string>, type?: Maybe<string>, value?: Maybe<string>, period?: Maybe<string> }>>> }> };

export type KpiDataVersionGetPublishedQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type KpiDataVersionGetPublishedQuery = { __typename?: 'Query', kpiDataVersionGetPublished?: Maybe<{ __typename?: 'KpiDataVersion', id?: Maybe<string>, accountId?: Maybe<string>, companyId?: Maybe<string>, templateId?: Maybe<string>, type?: Maybe<string>, editableByCurrentUser?: Maybe<boolean>, lockedAt?: Maybe<any>, lockedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }>, data?: Maybe<Array<Maybe<{ __typename?: 'KpiDataVersionData', indicatorId?: Maybe<string>, name?: Maybe<string>, type?: Maybe<string>, value?: Maybe<string>, period?: Maybe<string> }>>>, changeAudit?: Maybe<Array<Maybe<{ __typename?: 'KpiDataVersionChangeAudit', changed?: Maybe<any>, action?: Maybe<string>, changedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>> }> };

export type KpiDataVersionGetCurrentQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type KpiDataVersionGetCurrentQuery = { __typename?: 'Query', kpiDataVersionGetCurrent?: Maybe<{ __typename?: 'KpiDataVersion', id?: Maybe<string>, accountId?: Maybe<string>, companyId?: Maybe<string>, templateId?: Maybe<string>, type?: Maybe<string>, editableByCurrentUser?: Maybe<boolean>, lockedAt?: Maybe<any>, lockedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }>, data?: Maybe<Array<Maybe<{ __typename?: 'KpiDataVersionData', indicatorId?: Maybe<string>, name?: Maybe<string>, type?: Maybe<string>, value?: Maybe<string>, period?: Maybe<string> }>>>, changeAudit?: Maybe<Array<Maybe<{ __typename?: 'KpiDataVersionChangeAudit', changed?: Maybe<any>, action?: Maybe<string>, changedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>> }> };

export type KpiDataVersionListAuditsQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type KpiDataVersionListAuditsQuery = { __typename?: 'Query', kpiDataVersionListAudits?: Maybe<Array<Maybe<{ __typename?: 'KpiDataVersionChangeAudit', changed?: Maybe<any>, action?: Maybe<string>, changedBy?: Maybe<{ __typename?: 'KpiGlobalUser', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email?: Maybe<string> }> }>>> };

export type KpiIndicatorAddMutationVariables = Exact<{
  status: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  group: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}>;


export type KpiIndicatorAddMutation = { __typename?: 'Mutation', kpiIndicatorAdd?: Maybe<{ __typename?: 'KpiIndicator', id?: Maybe<string>, name?: Maybe<string>, status?: Maybe<KpiIndicatorStatus>, type?: Maybe<string>, group?: Maybe<string>, description?: Maybe<string> }> };

export type KpiIndicatorDeleteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type KpiIndicatorDeleteMutation = { __typename?: 'Mutation', kpiIndicatorDelete?: Maybe<{ __typename?: 'KpiIndicator', id?: Maybe<string>, name?: Maybe<string>, status?: Maybe<KpiIndicatorStatus>, type?: Maybe<string>, group?: Maybe<string>, description?: Maybe<string> }> };

export type KpiIndicatorUpdateMutationVariables = Exact<{
  id: Scalars['String'];
  status: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  group: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}>;


export type KpiIndicatorUpdateMutation = { __typename?: 'Mutation', kpiIndicatorUpdate?: Maybe<{ __typename?: 'KpiIndicator', id?: Maybe<string>, name?: Maybe<string>, status?: Maybe<KpiIndicatorStatus>, type?: Maybe<string>, group?: Maybe<string>, description?: Maybe<string> }> };

export type KpiIndicatorListQueryVariables = Exact<{ [key: string]: never; }>;


export type KpiIndicatorListQuery = { __typename?: 'Query', kpiIndicatorList?: Maybe<Array<Maybe<{ __typename?: 'KpiIndicator', id?: Maybe<string>, accountId?: Maybe<string>, name?: Maybe<string>, type?: Maybe<string>, group?: Maybe<string>, status?: Maybe<KpiIndicatorStatus>, description?: Maybe<string> }>>> };

export type KpiTemplateAddMutationVariables = Exact<{
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  indicators: Array<Maybe<KpiTemplateIndicatorInput>>;
  status: Scalars['String'];
}>;


export type KpiTemplateAddMutation = { __typename?: 'Mutation', kpiTemplateAdd?: Maybe<{ __typename?: 'KpiTemplate', id?: Maybe<string>, name?: Maybe<string>, status?: Maybe<KpiTemplateStatus>, description?: Maybe<string>, indicators?: Maybe<Array<Maybe<{ __typename?: 'KpiTemplateIndicator', id?: Maybe<string>, order?: Maybe<number> }>>> }> };

export type KpiTemplateDeleteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type KpiTemplateDeleteMutation = { __typename?: 'Mutation', kpiTemplateDelete?: Maybe<{ __typename?: 'KpiTemplate', id?: Maybe<string>, name?: Maybe<string> }> };

export type KpiTemplateUpdateMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  indicators: Array<Maybe<KpiTemplateIndicatorInput>>;
  status: Scalars['String'];
}>;


export type KpiTemplateUpdateMutation = { __typename?: 'Mutation', kpiTemplateUpdate?: Maybe<{ __typename?: 'KpiTemplate', id?: Maybe<string>, name?: Maybe<string>, status?: Maybe<KpiTemplateStatus>, description?: Maybe<string>, indicators?: Maybe<Array<Maybe<{ __typename?: 'KpiTemplateIndicator', id?: Maybe<string>, order?: Maybe<number> }>>> }> };

export type KpiTemplateListQueryVariables = Exact<{ [key: string]: never; }>;


export type KpiTemplateListQuery = { __typename?: 'Query', kpiTemplateList?: Maybe<Array<Maybe<{ __typename?: 'KpiTemplate', id?: Maybe<string>, accountId?: Maybe<string>, name?: Maybe<string>, status?: Maybe<KpiTemplateStatus>, description?: Maybe<string>, indicators?: Maybe<Array<Maybe<{ __typename?: 'KpiTemplateIndicator', id?: Maybe<string>, order?: Maybe<number> }>>> }>>> };

export type KpiTemplateGetQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type KpiTemplateGetQuery = { __typename?: 'Query', kpiTemplateGet?: Maybe<{ __typename?: 'KpiTemplate', id?: Maybe<string>, accountId?: Maybe<string>, name?: Maybe<string>, status?: Maybe<KpiTemplateStatus>, description?: Maybe<string>, indicators?: Maybe<Array<Maybe<{ __typename?: 'KpiTemplateIndicator', id?: Maybe<string>, order?: Maybe<number> }>>> }> };


export const KpiCompanyUpdateTemplateDocument = gql`
    mutation kpiCompanyUpdateTemplate($id: String!, $templateId: String) {
  kpiCompanyUpdateTemplate(id: $id, templateId: $templateId) {
    id
    accountId
    extId
    extStatus
    name
    templateId
    sectors
    created
    updated
  }
}
    `;
export type KpiCompanyUpdateTemplateMutationFn = Apollo.MutationFunction<KpiCompanyUpdateTemplateMutation, KpiCompanyUpdateTemplateMutationVariables>;

/**
 * __useKpiCompanyUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useKpiCompanyUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiCompanyUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiCompanyUpdateTemplateMutation, { data, loading, error }] = useKpiCompanyUpdateTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useKpiCompanyUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<KpiCompanyUpdateTemplateMutation, KpiCompanyUpdateTemplateMutationVariables>) {
        return Apollo.useMutation<KpiCompanyUpdateTemplateMutation, KpiCompanyUpdateTemplateMutationVariables>(KpiCompanyUpdateTemplateDocument, baseOptions);
      }
export type KpiCompanyUpdateTemplateMutationHookResult = ReturnType<typeof useKpiCompanyUpdateTemplateMutation>;
export type KpiCompanyUpdateTemplateMutationResult = Apollo.MutationResult<KpiCompanyUpdateTemplateMutation>;
export type KpiCompanyUpdateTemplateMutationOptions = Apollo.BaseMutationOptions<KpiCompanyUpdateTemplateMutation, KpiCompanyUpdateTemplateMutationVariables>;
export const KpiCompanyListDocument = gql`
    query kpiCompanyList {
  kpiCompanyList {
    id
    name
    templateId
    investments {
      fundName
      investmentAmount
      investmentDate
      currency
    }
    accountId
    extId
    extStatus
    sectors
    lastPublished
    lastPublishedBy {
      id
      firstName
      lastName
      email
    }
    lastStatus {
      status
      date
      user {
        id
        firstName
        lastName
        email
      }
    }
    dataCollectionStartDate {
      date
      updated
      updatedBy {
        id
        firstName
        lastName
        email
      }
    }
    dataCollectionFrequency {
      period
      updated
      updatedBy {
        id
        firstName
        lastName
        email
      }
    }
    created
    updated
  }
}
    `;

/**
 * __useKpiCompanyListQuery__
 *
 * To run a query within a React component, call `useKpiCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiCompanyListQuery({
 *   variables: {
 *   },
 * });
 */
export function useKpiCompanyListQuery(baseOptions?: Apollo.QueryHookOptions<KpiCompanyListQuery, KpiCompanyListQueryVariables>) {
        return Apollo.useQuery<KpiCompanyListQuery, KpiCompanyListQueryVariables>(KpiCompanyListDocument, baseOptions);
      }
export function useKpiCompanyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiCompanyListQuery, KpiCompanyListQueryVariables>) {
          return Apollo.useLazyQuery<KpiCompanyListQuery, KpiCompanyListQueryVariables>(KpiCompanyListDocument, baseOptions);
        }
export type KpiCompanyListQueryHookResult = ReturnType<typeof useKpiCompanyListQuery>;
export type KpiCompanyListLazyQueryHookResult = ReturnType<typeof useKpiCompanyListLazyQuery>;
export type KpiCompanyListQueryResult = Apollo.QueryResult<KpiCompanyListQuery, KpiCompanyListQueryVariables>;
export const KpiCompanyGetDocument = gql`
    query kpiCompanyGet($id: String!) {
  kpiCompanyGet(id: $id) {
    id
    name
    templateId
    investments {
      fundName
      investmentAmount
      investmentDate
      currency
    }
    accountId
    extId
    extStatus
    sectors
    lastPublished
    lastPublishedBy {
      id
      firstName
      lastName
      email
    }
    dataCollectionStartDate {
      date
      updated
      updatedBy {
        id
        firstName
        lastName
        email
      }
    }
    dataCollectionFrequency {
      period
      updated
      updatedBy {
        id
        firstName
        lastName
        email
      }
    }
    created
    updated
  }
}
    `;

/**
 * __useKpiCompanyGetQuery__
 *
 * To run a query within a React component, call `useKpiCompanyGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiCompanyGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiCompanyGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKpiCompanyGetQuery(baseOptions: Apollo.QueryHookOptions<KpiCompanyGetQuery, KpiCompanyGetQueryVariables>) {
        return Apollo.useQuery<KpiCompanyGetQuery, KpiCompanyGetQueryVariables>(KpiCompanyGetDocument, baseOptions);
      }
export function useKpiCompanyGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiCompanyGetQuery, KpiCompanyGetQueryVariables>) {
          return Apollo.useLazyQuery<KpiCompanyGetQuery, KpiCompanyGetQueryVariables>(KpiCompanyGetDocument, baseOptions);
        }
export type KpiCompanyGetQueryHookResult = ReturnType<typeof useKpiCompanyGetQuery>;
export type KpiCompanyGetLazyQueryHookResult = ReturnType<typeof useKpiCompanyGetLazyQuery>;
export type KpiCompanyGetQueryResult = Apollo.QueryResult<KpiCompanyGetQuery, KpiCompanyGetQueryVariables>;
export const KpiDataVersionUpdateDataDocument = gql`
    mutation kpiDataVersionUpdateData($companyId: String!, $data: [KpiDataVersionDataInput]) {
  kpiDataVersionUpdateData(companyId: $companyId, data: $data) {
    name
    indicatorId
    type
    value
    period
  }
}
    `;
export type KpiDataVersionUpdateDataMutationFn = Apollo.MutationFunction<KpiDataVersionUpdateDataMutation, KpiDataVersionUpdateDataMutationVariables>;

/**
 * __useKpiDataVersionUpdateDataMutation__
 *
 * To run a mutation, you first call `useKpiDataVersionUpdateDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiDataVersionUpdateDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiDataVersionUpdateDataMutation, { data, loading, error }] = useKpiDataVersionUpdateDataMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useKpiDataVersionUpdateDataMutation(baseOptions?: Apollo.MutationHookOptions<KpiDataVersionUpdateDataMutation, KpiDataVersionUpdateDataMutationVariables>) {
        return Apollo.useMutation<KpiDataVersionUpdateDataMutation, KpiDataVersionUpdateDataMutationVariables>(KpiDataVersionUpdateDataDocument, baseOptions);
      }
export type KpiDataVersionUpdateDataMutationHookResult = ReturnType<typeof useKpiDataVersionUpdateDataMutation>;
export type KpiDataVersionUpdateDataMutationResult = Apollo.MutationResult<KpiDataVersionUpdateDataMutation>;
export type KpiDataVersionUpdateDataMutationOptions = Apollo.BaseMutationOptions<KpiDataVersionUpdateDataMutation, KpiDataVersionUpdateDataMutationVariables>;
export const KpiCompanySetDataCollectionFrequencyDocument = gql`
    mutation kpiCompanySetDataCollectionFrequency($id: String!, $period: String!) {
  kpiCompanySetDataCollectionFrequency(id: $id, period: $period) {
    id
    dataCollectionStartDate {
      date
      updated
      updatedBy {
        id
        firstName
        lastName
        email
      }
    }
    dataCollectionFrequency {
      period
      updated
      updatedBy {
        id
        firstName
        lastName
        email
      }
    }
    created
    updated
  }
}
    `;
export type KpiCompanySetDataCollectionFrequencyMutationFn = Apollo.MutationFunction<KpiCompanySetDataCollectionFrequencyMutation, KpiCompanySetDataCollectionFrequencyMutationVariables>;

/**
 * __useKpiCompanySetDataCollectionFrequencyMutation__
 *
 * To run a mutation, you first call `useKpiCompanySetDataCollectionFrequencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiCompanySetDataCollectionFrequencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiCompanySetDataCollectionFrequencyMutation, { data, loading, error }] = useKpiCompanySetDataCollectionFrequencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useKpiCompanySetDataCollectionFrequencyMutation(baseOptions?: Apollo.MutationHookOptions<KpiCompanySetDataCollectionFrequencyMutation, KpiCompanySetDataCollectionFrequencyMutationVariables>) {
        return Apollo.useMutation<KpiCompanySetDataCollectionFrequencyMutation, KpiCompanySetDataCollectionFrequencyMutationVariables>(KpiCompanySetDataCollectionFrequencyDocument, baseOptions);
      }
export type KpiCompanySetDataCollectionFrequencyMutationHookResult = ReturnType<typeof useKpiCompanySetDataCollectionFrequencyMutation>;
export type KpiCompanySetDataCollectionFrequencyMutationResult = Apollo.MutationResult<KpiCompanySetDataCollectionFrequencyMutation>;
export type KpiCompanySetDataCollectionFrequencyMutationOptions = Apollo.BaseMutationOptions<KpiCompanySetDataCollectionFrequencyMutation, KpiCompanySetDataCollectionFrequencyMutationVariables>;
export const KpiCompanySetDataCollectionStartDateDocument = gql`
    mutation kpiCompanySetDataCollectionStartDate($id: String!, $date: String!) {
  kpiCompanySetDataCollectionStartDate(id: $id, date: $date) {
    id
    dataCollectionStartDate {
      date
      updated
      updatedBy {
        id
        firstName
        lastName
        email
      }
    }
    dataCollectionFrequency {
      period
      updated
      updatedBy {
        id
        firstName
        lastName
        email
      }
    }
    created
    updated
  }
}
    `;
export type KpiCompanySetDataCollectionStartDateMutationFn = Apollo.MutationFunction<KpiCompanySetDataCollectionStartDateMutation, KpiCompanySetDataCollectionStartDateMutationVariables>;

/**
 * __useKpiCompanySetDataCollectionStartDateMutation__
 *
 * To run a mutation, you first call `useKpiCompanySetDataCollectionStartDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiCompanySetDataCollectionStartDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiCompanySetDataCollectionStartDateMutation, { data, loading, error }] = useKpiCompanySetDataCollectionStartDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useKpiCompanySetDataCollectionStartDateMutation(baseOptions?: Apollo.MutationHookOptions<KpiCompanySetDataCollectionStartDateMutation, KpiCompanySetDataCollectionStartDateMutationVariables>) {
        return Apollo.useMutation<KpiCompanySetDataCollectionStartDateMutation, KpiCompanySetDataCollectionStartDateMutationVariables>(KpiCompanySetDataCollectionStartDateDocument, baseOptions);
      }
export type KpiCompanySetDataCollectionStartDateMutationHookResult = ReturnType<typeof useKpiCompanySetDataCollectionStartDateMutation>;
export type KpiCompanySetDataCollectionStartDateMutationResult = Apollo.MutationResult<KpiCompanySetDataCollectionStartDateMutation>;
export type KpiCompanySetDataCollectionStartDateMutationOptions = Apollo.BaseMutationOptions<KpiCompanySetDataCollectionStartDateMutation, KpiCompanySetDataCollectionStartDateMutationVariables>;
export const KpiDataVersionPublishDocument = gql`
    mutation kpiDataVersionPublish($companyId: String!) {
  kpiDataVersionPublish(companyId: $companyId) {
    id
    accountId
    templateId
    changeAudit {
      changedBy {
        id
        firstName
        lastName
        email
      }
      changed
      action
    }
    created
    updated
    lockedBy {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type KpiDataVersionPublishMutationFn = Apollo.MutationFunction<KpiDataVersionPublishMutation, KpiDataVersionPublishMutationVariables>;

/**
 * __useKpiDataVersionPublishMutation__
 *
 * To run a mutation, you first call `useKpiDataVersionPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiDataVersionPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiDataVersionPublishMutation, { data, loading, error }] = useKpiDataVersionPublishMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useKpiDataVersionPublishMutation(baseOptions?: Apollo.MutationHookOptions<KpiDataVersionPublishMutation, KpiDataVersionPublishMutationVariables>) {
        return Apollo.useMutation<KpiDataVersionPublishMutation, KpiDataVersionPublishMutationVariables>(KpiDataVersionPublishDocument, baseOptions);
      }
export type KpiDataVersionPublishMutationHookResult = ReturnType<typeof useKpiDataVersionPublishMutation>;
export type KpiDataVersionPublishMutationResult = Apollo.MutationResult<KpiDataVersionPublishMutation>;
export type KpiDataVersionPublishMutationOptions = Apollo.BaseMutationOptions<KpiDataVersionPublishMutation, KpiDataVersionPublishMutationVariables>;
export const KpiDataVersionLockDocument = gql`
    mutation kpiDataVersionLock($companyId: String!) {
  kpiDataVersionLock(companyId: $companyId) {
    id
    type
    editableByCurrentUser
    companyId
    lockedAt
    data {
      name
      indicatorId
      type
      value
      period
    }
    lockedBy {
      id
      firstName
      lastName
      email
    }
    created
    updated
  }
}
    `;
export type KpiDataVersionLockMutationFn = Apollo.MutationFunction<KpiDataVersionLockMutation, KpiDataVersionLockMutationVariables>;

/**
 * __useKpiDataVersionLockMutation__
 *
 * To run a mutation, you first call `useKpiDataVersionLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiDataVersionLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiDataVersionLockMutation, { data, loading, error }] = useKpiDataVersionLockMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useKpiDataVersionLockMutation(baseOptions?: Apollo.MutationHookOptions<KpiDataVersionLockMutation, KpiDataVersionLockMutationVariables>) {
        return Apollo.useMutation<KpiDataVersionLockMutation, KpiDataVersionLockMutationVariables>(KpiDataVersionLockDocument, baseOptions);
      }
export type KpiDataVersionLockMutationHookResult = ReturnType<typeof useKpiDataVersionLockMutation>;
export type KpiDataVersionLockMutationResult = Apollo.MutationResult<KpiDataVersionLockMutation>;
export type KpiDataVersionLockMutationOptions = Apollo.BaseMutationOptions<KpiDataVersionLockMutation, KpiDataVersionLockMutationVariables>;
export const KpiDataVersionUnlockDocument = gql`
    mutation kpiDataVersionUnlock($companyId: String!) {
  kpiDataVersionUnlock(companyId: $companyId) {
    id
    type
    editableByCurrentUser
    lockedAt
    lockedBy {
      id
      firstName
      lastName
      email
    }
    data {
      name
      indicatorId
      type
      value
      period
    }
    created
    updated
  }
}
    `;
export type KpiDataVersionUnlockMutationFn = Apollo.MutationFunction<KpiDataVersionUnlockMutation, KpiDataVersionUnlockMutationVariables>;

/**
 * __useKpiDataVersionUnlockMutation__
 *
 * To run a mutation, you first call `useKpiDataVersionUnlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiDataVersionUnlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiDataVersionUnlockMutation, { data, loading, error }] = useKpiDataVersionUnlockMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useKpiDataVersionUnlockMutation(baseOptions?: Apollo.MutationHookOptions<KpiDataVersionUnlockMutation, KpiDataVersionUnlockMutationVariables>) {
        return Apollo.useMutation<KpiDataVersionUnlockMutation, KpiDataVersionUnlockMutationVariables>(KpiDataVersionUnlockDocument, baseOptions);
      }
export type KpiDataVersionUnlockMutationHookResult = ReturnType<typeof useKpiDataVersionUnlockMutation>;
export type KpiDataVersionUnlockMutationResult = Apollo.MutationResult<KpiDataVersionUnlockMutation>;
export type KpiDataVersionUnlockMutationOptions = Apollo.BaseMutationOptions<KpiDataVersionUnlockMutation, KpiDataVersionUnlockMutationVariables>;
export const KpiDataVersionGetPublishedDocument = gql`
    query kpiDataVersionGetPublished($companyId: String!) {
  kpiDataVersionGetPublished(companyId: $companyId) {
    id
    accountId
    companyId
    templateId
    type
    editableByCurrentUser
    lockedBy {
      id
      firstName
      lastName
      email
    }
    lockedAt
    data {
      indicatorId
      name
      type
      value
      period
    }
    changeAudit {
      changedBy {
        id
        firstName
        lastName
        email
      }
      changed
      action
    }
  }
}
    `;

/**
 * __useKpiDataVersionGetPublishedQuery__
 *
 * To run a query within a React component, call `useKpiDataVersionGetPublishedQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiDataVersionGetPublishedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiDataVersionGetPublishedQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useKpiDataVersionGetPublishedQuery(baseOptions: Apollo.QueryHookOptions<KpiDataVersionGetPublishedQuery, KpiDataVersionGetPublishedQueryVariables>) {
        return Apollo.useQuery<KpiDataVersionGetPublishedQuery, KpiDataVersionGetPublishedQueryVariables>(KpiDataVersionGetPublishedDocument, baseOptions);
      }
export function useKpiDataVersionGetPublishedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiDataVersionGetPublishedQuery, KpiDataVersionGetPublishedQueryVariables>) {
          return Apollo.useLazyQuery<KpiDataVersionGetPublishedQuery, KpiDataVersionGetPublishedQueryVariables>(KpiDataVersionGetPublishedDocument, baseOptions);
        }
export type KpiDataVersionGetPublishedQueryHookResult = ReturnType<typeof useKpiDataVersionGetPublishedQuery>;
export type KpiDataVersionGetPublishedLazyQueryHookResult = ReturnType<typeof useKpiDataVersionGetPublishedLazyQuery>;
export type KpiDataVersionGetPublishedQueryResult = Apollo.QueryResult<KpiDataVersionGetPublishedQuery, KpiDataVersionGetPublishedQueryVariables>;
export const KpiDataVersionGetCurrentDocument = gql`
    query kpiDataVersionGetCurrent($companyId: String!) {
  kpiDataVersionGetCurrent(companyId: $companyId) {
    id
    accountId
    companyId
    templateId
    type
    editableByCurrentUser
    lockedBy {
      id
      firstName
      lastName
      email
    }
    lockedAt
    data {
      indicatorId
      name
      type
      value
      period
    }
    changeAudit {
      changedBy {
        id
        firstName
        lastName
        email
      }
      changed
      action
    }
  }
}
    `;

/**
 * __useKpiDataVersionGetCurrentQuery__
 *
 * To run a query within a React component, call `useKpiDataVersionGetCurrentQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiDataVersionGetCurrentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiDataVersionGetCurrentQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useKpiDataVersionGetCurrentQuery(baseOptions: Apollo.QueryHookOptions<KpiDataVersionGetCurrentQuery, KpiDataVersionGetCurrentQueryVariables>) {
        return Apollo.useQuery<KpiDataVersionGetCurrentQuery, KpiDataVersionGetCurrentQueryVariables>(KpiDataVersionGetCurrentDocument, baseOptions);
      }
export function useKpiDataVersionGetCurrentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiDataVersionGetCurrentQuery, KpiDataVersionGetCurrentQueryVariables>) {
          return Apollo.useLazyQuery<KpiDataVersionGetCurrentQuery, KpiDataVersionGetCurrentQueryVariables>(KpiDataVersionGetCurrentDocument, baseOptions);
        }
export type KpiDataVersionGetCurrentQueryHookResult = ReturnType<typeof useKpiDataVersionGetCurrentQuery>;
export type KpiDataVersionGetCurrentLazyQueryHookResult = ReturnType<typeof useKpiDataVersionGetCurrentLazyQuery>;
export type KpiDataVersionGetCurrentQueryResult = Apollo.QueryResult<KpiDataVersionGetCurrentQuery, KpiDataVersionGetCurrentQueryVariables>;
export const KpiDataVersionListAuditsDocument = gql`
    query kpiDataVersionListAudits($companyId: String!) {
  kpiDataVersionListAudits(companyId: $companyId) {
    changed
    action
    changedBy {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useKpiDataVersionListAuditsQuery__
 *
 * To run a query within a React component, call `useKpiDataVersionListAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiDataVersionListAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiDataVersionListAuditsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useKpiDataVersionListAuditsQuery(baseOptions: Apollo.QueryHookOptions<KpiDataVersionListAuditsQuery, KpiDataVersionListAuditsQueryVariables>) {
        return Apollo.useQuery<KpiDataVersionListAuditsQuery, KpiDataVersionListAuditsQueryVariables>(KpiDataVersionListAuditsDocument, baseOptions);
      }
export function useKpiDataVersionListAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiDataVersionListAuditsQuery, KpiDataVersionListAuditsQueryVariables>) {
          return Apollo.useLazyQuery<KpiDataVersionListAuditsQuery, KpiDataVersionListAuditsQueryVariables>(KpiDataVersionListAuditsDocument, baseOptions);
        }
export type KpiDataVersionListAuditsQueryHookResult = ReturnType<typeof useKpiDataVersionListAuditsQuery>;
export type KpiDataVersionListAuditsLazyQueryHookResult = ReturnType<typeof useKpiDataVersionListAuditsLazyQuery>;
export type KpiDataVersionListAuditsQueryResult = Apollo.QueryResult<KpiDataVersionListAuditsQuery, KpiDataVersionListAuditsQueryVariables>;
export const KpiIndicatorAddDocument = gql`
    mutation kpiIndicatorAdd($status: String!, $name: String!, $type: String!, $group: String!, $description: String) {
  kpiIndicatorAdd(input: {status: $status, name: $name, type: $type, group: $group, description: $description}) {
    id
    name
    status
    type
    group
    description
  }
}
    `;
export type KpiIndicatorAddMutationFn = Apollo.MutationFunction<KpiIndicatorAddMutation, KpiIndicatorAddMutationVariables>;

/**
 * __useKpiIndicatorAddMutation__
 *
 * To run a mutation, you first call `useKpiIndicatorAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiIndicatorAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiIndicatorAddMutation, { data, loading, error }] = useKpiIndicatorAddMutation({
 *   variables: {
 *      status: // value for 'status'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      group: // value for 'group'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useKpiIndicatorAddMutation(baseOptions?: Apollo.MutationHookOptions<KpiIndicatorAddMutation, KpiIndicatorAddMutationVariables>) {
        return Apollo.useMutation<KpiIndicatorAddMutation, KpiIndicatorAddMutationVariables>(KpiIndicatorAddDocument, baseOptions);
      }
export type KpiIndicatorAddMutationHookResult = ReturnType<typeof useKpiIndicatorAddMutation>;
export type KpiIndicatorAddMutationResult = Apollo.MutationResult<KpiIndicatorAddMutation>;
export type KpiIndicatorAddMutationOptions = Apollo.BaseMutationOptions<KpiIndicatorAddMutation, KpiIndicatorAddMutationVariables>;
export const KpiIndicatorDeleteDocument = gql`
    mutation kpiIndicatorDelete($id: String!) {
  kpiIndicatorDelete(id: $id) {
    id
    name
    status
    type
    group
    description
  }
}
    `;
export type KpiIndicatorDeleteMutationFn = Apollo.MutationFunction<KpiIndicatorDeleteMutation, KpiIndicatorDeleteMutationVariables>;

/**
 * __useKpiIndicatorDeleteMutation__
 *
 * To run a mutation, you first call `useKpiIndicatorDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiIndicatorDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiIndicatorDeleteMutation, { data, loading, error }] = useKpiIndicatorDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKpiIndicatorDeleteMutation(baseOptions?: Apollo.MutationHookOptions<KpiIndicatorDeleteMutation, KpiIndicatorDeleteMutationVariables>) {
        return Apollo.useMutation<KpiIndicatorDeleteMutation, KpiIndicatorDeleteMutationVariables>(KpiIndicatorDeleteDocument, baseOptions);
      }
export type KpiIndicatorDeleteMutationHookResult = ReturnType<typeof useKpiIndicatorDeleteMutation>;
export type KpiIndicatorDeleteMutationResult = Apollo.MutationResult<KpiIndicatorDeleteMutation>;
export type KpiIndicatorDeleteMutationOptions = Apollo.BaseMutationOptions<KpiIndicatorDeleteMutation, KpiIndicatorDeleteMutationVariables>;
export const KpiIndicatorUpdateDocument = gql`
    mutation kpiIndicatorUpdate($id: String!, $status: String!, $name: String!, $type: String!, $group: String!, $description: String) {
  kpiIndicatorUpdate(input: {id: $id, status: $status, name: $name, type: $type, group: $group, description: $description}) {
    id
    name
    status
    type
    group
    description
  }
}
    `;
export type KpiIndicatorUpdateMutationFn = Apollo.MutationFunction<KpiIndicatorUpdateMutation, KpiIndicatorUpdateMutationVariables>;

/**
 * __useKpiIndicatorUpdateMutation__
 *
 * To run a mutation, you first call `useKpiIndicatorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiIndicatorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiIndicatorUpdateMutation, { data, loading, error }] = useKpiIndicatorUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      group: // value for 'group'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useKpiIndicatorUpdateMutation(baseOptions?: Apollo.MutationHookOptions<KpiIndicatorUpdateMutation, KpiIndicatorUpdateMutationVariables>) {
        return Apollo.useMutation<KpiIndicatorUpdateMutation, KpiIndicatorUpdateMutationVariables>(KpiIndicatorUpdateDocument, baseOptions);
      }
export type KpiIndicatorUpdateMutationHookResult = ReturnType<typeof useKpiIndicatorUpdateMutation>;
export type KpiIndicatorUpdateMutationResult = Apollo.MutationResult<KpiIndicatorUpdateMutation>;
export type KpiIndicatorUpdateMutationOptions = Apollo.BaseMutationOptions<KpiIndicatorUpdateMutation, KpiIndicatorUpdateMutationVariables>;
export const KpiIndicatorListDocument = gql`
    query kpiIndicatorList {
  kpiIndicatorList {
    id
    accountId
    name
    type
    group
    status
    description
  }
}
    `;

/**
 * __useKpiIndicatorListQuery__
 *
 * To run a query within a React component, call `useKpiIndicatorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiIndicatorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiIndicatorListQuery({
 *   variables: {
 *   },
 * });
 */
export function useKpiIndicatorListQuery(baseOptions?: Apollo.QueryHookOptions<KpiIndicatorListQuery, KpiIndicatorListQueryVariables>) {
        return Apollo.useQuery<KpiIndicatorListQuery, KpiIndicatorListQueryVariables>(KpiIndicatorListDocument, baseOptions);
      }
export function useKpiIndicatorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiIndicatorListQuery, KpiIndicatorListQueryVariables>) {
          return Apollo.useLazyQuery<KpiIndicatorListQuery, KpiIndicatorListQueryVariables>(KpiIndicatorListDocument, baseOptions);
        }
export type KpiIndicatorListQueryHookResult = ReturnType<typeof useKpiIndicatorListQuery>;
export type KpiIndicatorListLazyQueryHookResult = ReturnType<typeof useKpiIndicatorListLazyQuery>;
export type KpiIndicatorListQueryResult = Apollo.QueryResult<KpiIndicatorListQuery, KpiIndicatorListQueryVariables>;
export const KpiTemplateAddDocument = gql`
    mutation kpiTemplateAdd($name: String!, $description: String, $indicators: [KpiTemplateIndicatorInput]!, $status: String!) {
  kpiTemplateAdd(input: {name: $name, description: $description, indicators: $indicators, status: $status}) {
    id
    name
    status
    description
    indicators {
      id
      order
    }
  }
}
    `;
export type KpiTemplateAddMutationFn = Apollo.MutationFunction<KpiTemplateAddMutation, KpiTemplateAddMutationVariables>;

/**
 * __useKpiTemplateAddMutation__
 *
 * To run a mutation, you first call `useKpiTemplateAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiTemplateAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiTemplateAddMutation, { data, loading, error }] = useKpiTemplateAddMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      indicators: // value for 'indicators'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useKpiTemplateAddMutation(baseOptions?: Apollo.MutationHookOptions<KpiTemplateAddMutation, KpiTemplateAddMutationVariables>) {
        return Apollo.useMutation<KpiTemplateAddMutation, KpiTemplateAddMutationVariables>(KpiTemplateAddDocument, baseOptions);
      }
export type KpiTemplateAddMutationHookResult = ReturnType<typeof useKpiTemplateAddMutation>;
export type KpiTemplateAddMutationResult = Apollo.MutationResult<KpiTemplateAddMutation>;
export type KpiTemplateAddMutationOptions = Apollo.BaseMutationOptions<KpiTemplateAddMutation, KpiTemplateAddMutationVariables>;
export const KpiTemplateDeleteDocument = gql`
    mutation kpiTemplateDelete($id: String!) {
  kpiTemplateDelete(id: $id) {
    id
    name
  }
}
    `;
export type KpiTemplateDeleteMutationFn = Apollo.MutationFunction<KpiTemplateDeleteMutation, KpiTemplateDeleteMutationVariables>;

/**
 * __useKpiTemplateDeleteMutation__
 *
 * To run a mutation, you first call `useKpiTemplateDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiTemplateDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiTemplateDeleteMutation, { data, loading, error }] = useKpiTemplateDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKpiTemplateDeleteMutation(baseOptions?: Apollo.MutationHookOptions<KpiTemplateDeleteMutation, KpiTemplateDeleteMutationVariables>) {
        return Apollo.useMutation<KpiTemplateDeleteMutation, KpiTemplateDeleteMutationVariables>(KpiTemplateDeleteDocument, baseOptions);
      }
export type KpiTemplateDeleteMutationHookResult = ReturnType<typeof useKpiTemplateDeleteMutation>;
export type KpiTemplateDeleteMutationResult = Apollo.MutationResult<KpiTemplateDeleteMutation>;
export type KpiTemplateDeleteMutationOptions = Apollo.BaseMutationOptions<KpiTemplateDeleteMutation, KpiTemplateDeleteMutationVariables>;
export const KpiTemplateUpdateDocument = gql`
    mutation kpiTemplateUpdate($id: String!, $name: String!, $description: String, $indicators: [KpiTemplateIndicatorInput]!, $status: String!) {
  kpiTemplateUpdate(input: {id: $id, name: $name, description: $description, indicators: $indicators, status: $status}) {
    id
    name
    status
    description
    indicators {
      id
      order
    }
  }
}
    `;
export type KpiTemplateUpdateMutationFn = Apollo.MutationFunction<KpiTemplateUpdateMutation, KpiTemplateUpdateMutationVariables>;

/**
 * __useKpiTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useKpiTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKpiTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kpiTemplateUpdateMutation, { data, loading, error }] = useKpiTemplateUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      indicators: // value for 'indicators'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useKpiTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<KpiTemplateUpdateMutation, KpiTemplateUpdateMutationVariables>) {
        return Apollo.useMutation<KpiTemplateUpdateMutation, KpiTemplateUpdateMutationVariables>(KpiTemplateUpdateDocument, baseOptions);
      }
export type KpiTemplateUpdateMutationHookResult = ReturnType<typeof useKpiTemplateUpdateMutation>;
export type KpiTemplateUpdateMutationResult = Apollo.MutationResult<KpiTemplateUpdateMutation>;
export type KpiTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<KpiTemplateUpdateMutation, KpiTemplateUpdateMutationVariables>;
export const KpiTemplateListDocument = gql`
    query kpiTemplateList {
  kpiTemplateList {
    id
    accountId
    name
    indicators {
      id
      order
    }
    status
    description
  }
}
    `;

/**
 * __useKpiTemplateListQuery__
 *
 * To run a query within a React component, call `useKpiTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiTemplateListQuery({
 *   variables: {
 *   },
 * });
 */
export function useKpiTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<KpiTemplateListQuery, KpiTemplateListQueryVariables>) {
        return Apollo.useQuery<KpiTemplateListQuery, KpiTemplateListQueryVariables>(KpiTemplateListDocument, baseOptions);
      }
export function useKpiTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiTemplateListQuery, KpiTemplateListQueryVariables>) {
          return Apollo.useLazyQuery<KpiTemplateListQuery, KpiTemplateListQueryVariables>(KpiTemplateListDocument, baseOptions);
        }
export type KpiTemplateListQueryHookResult = ReturnType<typeof useKpiTemplateListQuery>;
export type KpiTemplateListLazyQueryHookResult = ReturnType<typeof useKpiTemplateListLazyQuery>;
export type KpiTemplateListQueryResult = Apollo.QueryResult<KpiTemplateListQuery, KpiTemplateListQueryVariables>;
export const KpiTemplateGetDocument = gql`
    query kpiTemplateGet($id: String!) {
  kpiTemplateGet(id: $id) {
    id
    accountId
    name
    indicators {
      id
      order
    }
    status
    description
  }
}
    `;

/**
 * __useKpiTemplateGetQuery__
 *
 * To run a query within a React component, call `useKpiTemplateGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiTemplateGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiTemplateGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKpiTemplateGetQuery(baseOptions: Apollo.QueryHookOptions<KpiTemplateGetQuery, KpiTemplateGetQueryVariables>) {
        return Apollo.useQuery<KpiTemplateGetQuery, KpiTemplateGetQueryVariables>(KpiTemplateGetDocument, baseOptions);
      }
export function useKpiTemplateGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiTemplateGetQuery, KpiTemplateGetQueryVariables>) {
          return Apollo.useLazyQuery<KpiTemplateGetQuery, KpiTemplateGetQueryVariables>(KpiTemplateGetDocument, baseOptions);
        }
export type KpiTemplateGetQueryHookResult = ReturnType<typeof useKpiTemplateGetQuery>;
export type KpiTemplateGetLazyQueryHookResult = ReturnType<typeof useKpiTemplateGetLazyQuery>;
export type KpiTemplateGetQueryResult = Apollo.QueryResult<KpiTemplateGetQuery, KpiTemplateGetQueryVariables>;